import { rankingData } from '@/mocks/homeData';

function getTrendIcon(trend: string) {
  if (trend === 'up') return 'ri-arrow-up-line text-accent-500';
  if (trend === 'down') return 'ri-arrow-down-line text-secondary-400';
  return 'ri-add-line text-primary-500';
}

function getRankColor(rank: number) {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-accent-500 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-600';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            实时榜单
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {rankingData.title}
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto space-y-2">
          {rankingData.items.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-lg p-4 hover:bg-background-100 transition-colors"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${getRankColor(item.rank)}`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-900 truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs font-bold text-primary-500 whitespace-nowrap">
                  {item.heat}
                </span>
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${getTrendIcon(item.trend)} text-sm`}></i>
                  </div>
                  <span
                    className={`text-xs whitespace-nowrap ${
                      item.trend === 'up'
                        ? 'text-accent-600'
                        : item.trend === 'down'
                          ? 'text-secondary-400'
                          : 'text-primary-500'
                    }`}
                  >
                    {item.change}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}